import React, { Component, Fragment } from 'react';
import { Segment, Header, Form, Grid, Loader, Button, Popup, Input } from 'semantic-ui-react';
import {
    fetchCountries,
    fetchGenderName,
    fetchStudyCycle
} from '../../Lookups/util';
import { FormattedMessage } from 'react-intl';
import { DateTimePicker } from 'react-widgets';
import axios from 'axios';

class ExternalStudentPersonalInformationForm extends Component {
    constructor(props) {
        super(props);
        this.state = {
            genderOptions: [],
            countryOptions: [],
            studyCycleOptions: [],
            englishLevelCompetenceOptions: [],
            loadingOptions: true,
            onChangeStudent: props.onChangeStudent,
            onSave: props.onSave,
            onCancel: props.onCancel,
        };
    }

    componentDidMount() {
        const axiosCallFactories =
            this.props.publicForm
                ? [
                    () => axios.get('public/external-student/genders'),
                    () => axios.get('public/external-student/countries'),
                    () => axios.get('public/external-student/study-cycles'),
                    () => axios.get('public/external-student/language-proficiency-levels')
                ]
                : [
                    () => fetchGenderName(),
                    () => fetchCountries(),
                    () => fetchStudyCycle(),
                    () => axios.get('/language-proficiency-levels')
                ];
        Promise.all(axiosCallFactories.map(fn => fn()))
            .then(([genders, countries, cycles, englishLevelCompetences]) => {
                this.setState({
                    genderOptions: genders.data.map((el) => ({
                        key: el.id,
                        value: el,
                        text: ((window.$locale !== 'bs' && el.translations.length) ? el.translations.find(e => e.language === window.$locale).name : el.name),
                    })),
                    countryOptions: countries.data.map((el) => ({
                        key: el.id,
                        value: el,
                        text: ((window.$locale !== 'bs' && el.translations.length) ? el.translations.find(e => e.language === window.$locale).name : el.name),
                    })),
                    studyCycleOptions: cycles.data.map((el) => ({
                        key: el.id,
                        value: el,
                        text: ((window.$locale !== 'bs' && el.translations.length) ? el.translations.find(e => e.language === window.$locale).name : el.name),
                    })),
                    englishLevelCompetenceOptions: englishLevelCompetences.data.map((el) => ({
                        key: el.id,
                        value: el,
                        text: `${el.abbreviation} - ${((window.$locale !== 'bs' && el.translations.length) ? el.translations.find(e => e.language === window.$locale).name : el.name)}`
                    })),
                    loadingOptions: false
                });
            });
    }

    render() {
        const {
            genderOptions,
            countryOptions,
            loadingOptions,
            englishLevelCompetenceOptions,
            onSave,
            onCancel,
            onChangeStudent,
        } = this.state;
        const {
            student,
            errors
        } = this.props;

        return (
            <Grid.Column>
                <Segment.Group>
                    <Segment>
                        <Header as="h3">
                            <Header.Content style={{
                                display: 'flex',
                                justifyContent: 'space-between'
                            }}>
                                <FormattedMessage id="externalStudent.personalData"/>
                                {this.props.edit && !loadingOptions && (
                                    <div>
                                        <Popup
                                            content={<FormattedMessage id="externalStudent.cancel"/>}
                                            position="top center"
                                            trigger={<Button floated="right" icon="cancel" basic color="red" circular
                                                             size="mini" loading={loadingOptions} onClick={onCancel}/>}
                                        />
                                        <Popup
                                            content={<FormattedMessage id="externalStudent.edit"/>}
                                            position="top center"
                                            trigger={<Button floated="right" icon="check" basic color="green" circular
                                                             size="mini" loading={loadingOptions} onClick={() => {
                                                onSave(student);
                                            }}/>}
                                        />
                                    </div>
                                )}
                            </Header.Content>
                        </Header>
                    </Segment>
                    <Segment>
                        {loadingOptions ? (
                            <div style={{
                                paddingTop: '100px',
                                paddingBottom: '100px'
                            }}
                            ><Loader active inline="centered"/></div>
                        ) : (
                            <Form>
                                <Form.Field required error={errors.firstNameErr}>
                                    <label><FormattedMessage id="externalStudent.firstName"/></label>
                                    <FormattedMessage id="externalStudent.enterFirstName">
                                        {msg => (
                                            <Input
                                                placeholder={msg}
                                                value={student.firstName || ''}
                                                onChange={(e, { value }) => onChangeStudent({ firstName: value })}
                                            />
                                        )}
                                    </FormattedMessage>
                                </Form.Field>
                                <Form.Field required error={errors.lastNameErr}>
                                    <label><FormattedMessage id="externalStudent.lastName"/></label>
                                    <FormattedMessage id="externalStudent.enterLastName">
                                        {msg => (
                                            <Input
                                                placeholder={msg}
                                                value={student.lastName || ''}
                                                onChange={(e, { value }) => onChangeStudent({ lastName: value })}
                                            />
                                        )}
                                    </FormattedMessage>
                                </Form.Field>
                                <Form.Field required error={errors.emailErr}>
                                    <label><FormattedMessage id="externalStudent.email"/></label>
                                    <FormattedMessage id="externalStudent.enterEmail">
                                        {msg => (
                                            <Input
                                                placeholder={msg}
                                                value={student.email || ''}
                                                onChange={(e, { value }) => onChangeStudent({ email: value })}
                                            />
                                        )}
                                    </FormattedMessage>
                                </Form.Field>
                                <Form.Field required error={errors.dateOfBirthErr}>
                                    <label><FormattedMessage id="externalStudent.birthDate"/></label>
                                    <FormattedMessage id="externalStudent.enterBirthDate">
                                        {msg => (
                                            <DateTimePicker
                                                format="D. M. YYYY."
                                                time={false}
                                                placeholder={msg}
                                                value={student.dateOfBirth ? new Date(student.dateOfBirth) : null}
                                                onChange={(value) => onChangeStudent({ dateOfBirth: value })}
                                            />
                                        )}
                                    </FormattedMessage>
                                </Form.Field>
                                <Form.Field required>
                                    <label><FormattedMessage id="externalStudent.gender"/></label>
                                    <Form.Dropdown
                                        search
                                        options={genderOptions}
                                        value={student.gender || null}
                                        selection
                                        clearable
                                        placeholder={<FormattedMessage id="externalStudent.selectGender"/>}
                                        onChange={(e, { value }) => onChangeStudent({ gender: value })}
                                        error={errors.genderErr}
                                    />
                                </Form.Field>
                                <Form.Field required>
                                    <label><FormattedMessage id="externalStudent.birthCountry"/></label>
                                    <Form.Dropdown
                                        search
                                        options={countryOptions}
                                        value={student.birthCountry || null}
                                        selection
                                        clearable
                                        placeholder={<FormattedMessage id="externalStudent.selectBirthCountry"/>}
                                        onChange={(e, { value }) => onChangeStudent({ birthCountry: value })}
                                        error={errors.birthCountryErr}
                                    />
                                </Form.Field>
                                <Form.Field required error={errors.birthPlaceNameErr}>
                                    <label><FormattedMessage id="externalStudent.birthPlaceName"/></label>
                                    <FormattedMessage id="externalStudent.enterBirthPlaceName">
                                        {msg => (
                                            <Input
                                                placeholder={msg}
                                                value={student.birthPlaceName || ''}
                                                onChange={(e, { value }) => onChangeStudent({ birthPlaceName: value })}
                                            />
                                        )}
                                    </FormattedMessage>
                                </Form.Field>
                                <Form.Field required>
                                    <label><FormattedMessage id="externalStudent.citizenshipCountry"/></label>
                                    <Form.Dropdown
                                        search
                                        options={countryOptions}
                                        value={student.citizenshipCountry || null}
                                        selection
                                        clearable
                                        placeholder={<FormattedMessage id="externalStudent.selectCitizenshipCountry"/>}
                                        onChange={(e, { value }) => onChangeStudent({ citizenshipCountry: value })}
                                        error={errors.citizenshipCountryErr}
                                    />
                                </Form.Field>
                                <Form.Field required error={errors.jmbgErr}>
                                    <label><FormattedMessage id="externalStudent.jmbg"/></label>
                                    <FormattedMessage id="externalStudent.enterJmbg">
                                        {msg => (
                                            <Input
                                                placeholder={msg}
                                                value={student.jmbg || ''}
                                                onChange={(e, { value }) => onChangeStudent({ jmbg: value })}
                                            />
                                        )}
                                    </FormattedMessage>
                                </Form.Field>
                                <Form.Field required>
                                    <label><FormattedMessage id="externalStudent.englishLevelCompetence"/></label>
                                    <Form.Dropdown
                                        search
                                        options={englishLevelCompetenceOptions}
                                        value={student.englishLevelCompetence || null}
                                        selection
                                        clearable
                                        placeholder={<FormattedMessage
                                            id="externalStudent.selectEnglishLevelCompetence"/>}
                                        onChange={(e, { value }) => onChangeStudent({ englishLevelCompetence: value })}
                                        error={errors.englishLevelCompetenceErr}
                                    />
                                </Form.Field>
                                <Form.Field error={errors.europeanStudentIdentifierErr}>
                                    <label><FormattedMessage id="externalStudent.esi"/></label>
                                    <FormattedMessage id="externalStudent.enterEsi">
                                        {msg => (
                                            <Input
                                                placeholder={msg}
                                                value={student.europeanStudentIdentifier || ''}
                                                onChange={(e, { value }) => onChangeStudent({ europeanStudentIdentifier: value })}
                                            />
                                        )}
                                    </FormattedMessage>
                                </Form.Field>
                            </Form>
                        )}
                    </Segment>
                </Segment.Group>
            </Grid.Column>
        );
    }
}

export default ExternalStudentPersonalInformationForm;



// WEBPACK FOOTER //
// ./src/views/ExternalStudents/ExternalStudentForms/ExternalStudentPersonalInformationForm.js